import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';

import { APP_OPTIONS, SEARCHKIT_HOST_URL } from '../../config/constants';
import { resultAttributes, sorting } from './config';

// Subcomponents.
import Results from './Results';
import Pagination from './Pagination';

interface SearchForumCategoriesSubcomponents {
  Results: typeof Results;
  Pagination: typeof Pagination;
}

export interface SearchForumCategoriesProps extends Omit<SearchkitWrapperProps, 'connection' | 'indexName' | 'routing' | 'analytics' | 'hitsPerPage' | 'searchSettings' | 'requestOptions'> {
  className?: string;
}

// eslint-disable-next-line max-len
const SearchForumCategories: React.FC<SearchForumCategoriesProps> & SearchForumCategoriesSubcomponents = (props) => {
  const {
    className,
    children,
    ...restProps
  } = props;

  const classNames = c('SearchForumCategories', className);
  const hitsPerPage = 20;

  return (
    <SearchkitWrapper
      {...restProps}
      className={classNames}
      connection={{ host: SEARCHKIT_HOST_URL }}
      indexName={APP_OPTIONS.parameters.searchkitIndexForumCategories}
      analytics={false}
      hitsPerPage={hitsPerPage}
      searchSettings={{
        search_attributes: [],
        result_attributes: resultAttributes,
        sorting,
      }}
      requestOptions={{
        // Category needs to be published.
        getBaseFilters: () => [
          {
            bool: {
              must: [
                {
                  term: {
                    status: { value: true },
                  },
                },
              ],
            },
          },
        ],
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchForumCategories.Results = Results;
SearchForumCategories.Pagination = Pagination;

export default SearchForumCategories;
